'use client';

import { ModalContent } from '@components/modal-content/ModalContent';
import { saveNewsScrollPosition } from '@lib/tools/scroll/scrollPosition';
import { useRouter } from 'next/navigation';

export default function NewsModalClient({ item, sliderData, isBack }) {
  const router = useRouter();

  const handleCloseModal = () => {
    saveNewsScrollPosition();
    isBack ? router.back() : router.replace('/news', { scroll: false });
  };

  return <ModalContent item={item} sliderData={sliderData} handleCloseModal={handleCloseModal} />;
}
